import Insight from "../insightClass";
import React from "react";
import { insight8Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight048 = new Insight(
  "30 May 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight8Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-05-30)",
  "",
  `BloombergNEF warns the UK is on course to miss its 2030 offshore wind goal of 43GW, projecting only 33GW will be operational. Rising costs, supply chain constraints, and planning delays have led to project slowdowns, including Ørsted's Hornsea 4 and SSE's Berwick Bank.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-05-30)</h1>
    <h2></h2>
    <p className="article-date">30 May 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>1. UK Likely to Miss 2030 Offshore Wind Target </h3>
    <p>
      BloombergNEF warns the UK is on course to miss its 2030 offshore wind goal
      of 43GW, projecting only 33GW will be operational. Rising costs, supply
      chain constraints, and planning delays have led to project slowdowns,
      including Ørsted's Hornsea 4 and SSE's Berwick Bank.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      This shortfall underscores the urgent need for streamlined permitting
      processes and robust supply chain strategies. Developers must adapt to
      economic pressures by exploring innovative financing and project
      management approaches to stay on track.
    </p>
    <h3>2. Poland Advances Offshore Wind Turbine Factory Project </h3>
    <p>
      Windar Renovables lays the cornerstone for a 47,000 sqm offshore wind
      turbine factory in Szczecin, Poland, expected to create 450 jobs. The
      facility aims to bolster Poland's position in the global renewables
      market.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      Investing in manufacturing infrastructure is crucial for supply chain
      resilience. Poland's initiative demonstrates the strategic value of
      localizing production to support offshore wind growth and economic
      development.
    </p>
    <h3>3. Poland's Bałtyk 2 & 3 Projects Reach Final Investment Decision</h3>
    <p>
      Equinor and Polenergia have finalized investment decisions for the Bałtyk
      2 and 3 offshore wind farms in the Baltic Sea. With a combined capacity of
      1.4 GW, these projects represent a €7.2 billion investment, aiming to
      supply electricity to two million Polish homes and enhance the country's
      energy independence.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      This milestone underscores Poland's commitment to expanding its offshore
      wind capacity. The substantial investment reflects confidence in the
      sector's growth potential and the strategic importance of diversifying
      energy sources to strengthen national energy security.
    </p>
    <h3>
      4. Swedish Startup SeaTwirl Advances Vertical Axis Floating Wind Turbines
    </h3>
    <p>
      SeaTwirl, a Swedish company, is progressing with the development of
      vertical axis floating offshore wind turbines, securing €15 million from
      the EU's Horizon Europe program for a 2 MW demonstration project. This
      technology aims to offer cost-effective solutions for deep-water wind
      energy generation.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      Innovations like SeaTwirl's vertical axis turbines could revolutionize
      floating offshore wind by simplifying design and maintenance, particularly
      in deep-sea environments. Successful demonstration may open new markets
      and applications, enhancing the versatility and reach of offshore wind
      energy.
    </p>
    <h3>5. South Korea Announces 1.25 GW Offshore Wind Tender </h3>
    <p>
      South Korea's Energy Agency has announced a competitive bidding process
      for 1.25 GW of fixed-bottom offshore wind projects in the first half of
      2025. The tender includes 500 MW through public-led bidding and 750 MW via
      general bidding. A new security index will be introduced in the evaluation
      criteria, focusing on the stability of power generation facilities and
      energy supply.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      South Korea's Energy Agency has announced a competitive bidding process
      for 1.25 GW of fixed-bottom offshore wind projects in the first half of
      2025. The tender includes 500 MW through public-led bidding and 750 MW via
      general bidding. A new security index will be introduced in the evaluation
      criteria, focusing on the stability of power generation facilities and
      energy supply.
    </p>
    <h3>6. Japan Considers Policy Reforms to Revive Offshore Wind Sector</h3>
    <p>
      Facing stalled projects and developer withdrawals, Japan is contemplating
      policy changes to rejuvenate its offshore wind ambitions. Proposed reforms
      include extending project durations, relaxing cabotage laws, and shifting
      to a feed-in premium system to enhance profitability.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      Japan's proactive stance in addressing industry concerns demonstrates a
      commitment to renewable energy goals. These policy adjustments could
      restore investor confidence and accelerate project timelines, serving as a
      model for other emerging offshore wind markets.
    </p>
    <h3>7. Philippines' First Large-Scale Offshore Wind Project Advances </h3>
    <p>
      The San Miguel Bay 1 project, the Philippines' first large-scale offshore
      wind farm, progresses with a partnership between Copenhagen Infrastructure
      Partners and ACEN. The 1GW project aims to strengthen the Luzon grid and
      meet rising energy demand.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      This development highlights the growing interest in offshore wind in
      Southeast Asia. Successful implementation could pave the way for regional
      expansion, offering lessons in navigating regulatory landscapes and
      fostering international collaborations.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
